<template>
  <div class="card">
    <div class="card-body form-horizontal form-cs-n">
      <div class="row mt-15">
        <div class="col-md-6">
          <!-- <button class="btn btn-sm btn-secondary" @click="downloadAll()">Download All</button> -->
          <download class="pull-left" :tableId="'s1s-sector'" :fileName="'s1s-sector'"></download>
        </div>
        <div class="col-md-6">
        </div>
      </div>
      <!-- ######## -->
      <!-- NEW TABLE -->
      <!-- ######## -->
      <div class="table-responsive app mb-15" v-dragscroll="true">
        <table id="s1s-sector" class="table table-bordered app-inner" style="font-size: 11px;">
          <thead v-if="tableFields.length > 0">
            <tr>
              <th class="align-middle" v-for="(lblObj, lIdx) in tableFields">{{ getLabel(lblObj.title) }}</th>
            </tr>
          </thead>
          <tbody v-if="tableFields.length > 0">
            <tr v-for="(row, index, key) in rawData" v-bind:key="'row' + row + index">
              <!-- <td>{{ (parseInt(page) === 1) ? (index + 1) : (((parseInt(page) - 1) * perPage) + (index + 1)) }}</td> -->
              <td v-for="(fieldObj, ind) in tableFields" v-bind:key="ind + '-td-' + index + key">
                <!-- { title: "actual sales growth cagr 5 years", field: "s1_data", sub_field: "actual_sales_growth_cagr_5_years" }, -->
                <span>
                  <a v-if="fieldObj.sub_field == ''" class="a-btn">{{ row[fieldObj.field] }}</a>
                  <a v-else class="a-btn">{{ row[fieldObj.field][fieldObj.sub_field] }}</a>
                </span>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="rawData.length === 0">
            <tr>
              <td :colspan="tableFields.length">
                <div class="alert alert-danger" role="alert">No data found!</div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <!-- ######## -->
      <!-- NEW TABLE -->
      <!-- ######## -->
      <div class="row mt-15">
        <div class="col-md-6">
          <!-- <button class="btn btn-sm btn-secondary " @click="downloadAll()">Download All</button> -->
          <download class="pull-left" :tableId="'s1s-sector'" :fileName="'s1s-sector'"></download>
        </div>
        <div class="col-md-1" v-if="searchData.length > 0">
          <download :tableId="'s1s-sector'" :fileName="'s1s-sector'"></download>
        </div>
        <div class="col-md-5">
          <!-- <pagination
            ref="page"
            :pageName="type"
            :totPages="totalPages"
            :apiUrl="rawDataApi"
            @changePage="pageChange"
          ></pagination>-->
          <div class="pull-right">
            <ul v-if="totalPages != 1" class="pagination">
              <li :class="{ disabled: prevDisabled }" class="page-item">
                <a class="page-link" @click.prevent="goToPage(1)" href="#">{{ '&lt;&lt;' }}</a>
              </li>
              <li :class="{ disabled: prevDisabled }" class="page-item">
                <a class="page-link" @click.prevent="prev()" href="#">{{ '&lt;' }}</a>
              </li>
              <li v-for="page in pages" v-bind:key="page" class="page-item"
                :class="(current_page == page) ? 'active' : ''">
                <a class="page-link" @click.prevent="goToPage(page)" href="#">{{ page }}</a>
              </li>
              <li :class="{ disabled: nextDisabled }" class="page-item">
                <a class="page-link" href="#" @click.prevent="next()">{{ '&gt;' }}</a>
              </li>
              <li :class="{ disabled: nextDisabled }" class="page-item">
                <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">{{ '&gt;&gt;' }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { pCommonMixins } from "../../assets/mixins/pcommon.js";
import Datepicker from "vuejs-datepicker";

export default {
  components: { Datepicker },
  mixins: [commonMixins, pCommonMixins],
  props: ["sectorList"],
  mounted() {
    console.log('mounted sectorList', this.sectorList);
    //this.getS1SectorData();
  },
  created() {
    console.log('created sectorList', this.sectorList);
    // let routeData = this.$router.resolve({ path: "/filtered-s1" });
    // console.log("this.$route.query.page", this.$route, routeData);
    // window.open(routeData.href, "_blank");
    //this.getS1Data();
    //this.getS1SectorData();
    /* this.selFilter[0] = "p11_actual";
    this.selFilter[1] = "q1_a_b_greater";
    this.selFilter[2] = "p11_quarterly_trends";
    this.minRange[0] = this.minRange[1] = this.minRange[2] = this.maxRange[0] = this.maxRange[1] = this.maxRange[2] = "";
    this.tableFields = this.s1Data; */
    /* this.getLabel('L-1_qtr_YOY_eps') */
  },
  data() {
    return {
      ddate: new Date().setDate(new Date().getDate() - 1),
      tableFields: [
        { title: "Code", field: "co_code", sub_field: "" },
        { title: "Date", field: "date", sub_field: "" },
        { title: "Insert Date", field: "insert_date", sub_field: "" },
        { title: "Company", field: "name", sub_field: "" },
        { title: "Market Capitalization", field: "market_capitalization", sub_field: "" },
        { title: "P11", field: "p11_quarterly_trends", sub_field: "" },
        { title: "Greater Q1A / Q1B", field: "q1_a_b_greater", sub_field: "" },
        { title: "L-1 qtr YOY eps", field: "s1_data", sub_field: "L-1_qtr_YOY_eps" },
        { title: "L-1 qtr YOY net sales", field: "s1_data", sub_field: "L-1_qtr_YOY_net_sales" },
        { title: "L qtr YOY eps", field: "s1_data", sub_field: "L_qtr_YOY_eps" },
        { title: "L qtr YOY net sales", field: "s1_data", sub_field: "L_qtr_YOY_net_sales" },
        { title: "Promoter Pledge Shares Percentage", field: "s1_data", sub_field: "Promoter_PledgeSharesPercentage" },
        { title: "Actual Earnings Growth CAGR 10 years", field: "s1_data", sub_field: "actual_earnings_growth_cagr_10_years" },
        { title: "Actual Earnings Growth CAGR 5 years", field: "s1_data", sub_field: "actual_earnings_growth_cagr_5_years" },
        { title: "Actual eps growth cagr 10 years", field: "s1_data", sub_field: "actual_eps_growth_cagr_10_years" },
        { title: "Actual eps growth cagr 5 years", field: "s1_data", sub_field: "actual_eps_growth_cagr_5_years" },
        { title: "Actual Latest CFO per ebitda", field: "s1_data", sub_field: "actual_latest_cfo_per_ebitda" },
        { title: "Actual Latest debtors per creditors", field: "s1_data", sub_field: "actual_latest_debtors_per_creditors" },
        { title: "Actual Latest ebitDA per sales", field: "s1_data", sub_field: "actual_latest_ebitDA_per_sales" },
        { title: "Actual Latest Lna per net worth", field: "s1_data", sub_field: "actual_latest_lna_per_net_worth" },
        { title: "Actual Latest ROE", field: "s1_data", sub_field: "actual_latest_roe" },
        { title: "Actual Latest Sales Per Invested_capital", field: "s1_data", sub_field: "actual_latest_sales_per_invested_capital" },
        { title: "Actual Latest tax per pbt", field: "s1_data", sub_field: "actual_latest_tax_per_pbt" },
        { title: "actual latest total debt per net worth", field: "s1_data", sub_field: "actual_latest_total_debt_per_net_worth" },
        { title: "actual market share", field: "s1_data", sub_field: "actual_market_share" },
        { title: "actual market share color", field: "s1_data", sub_field: "actual_market_share_color" },
        { title: "actual retained earning", field: "s1_data", sub_field: "actual_retained_earning" },
        { title: "actual sales growth cagr 10 years", field: "s1_data", sub_field: "actual_sales_growth_cagr_10_years" },
        { title: "actual sales growth cagr 5 years", field: "s1_data", sub_field: "actual_sales_growth_cagr_5_years" },
        { title: "assets heavy or light", field: "s1_data", sub_field: "assets_heavy_or_light" },
        { title: "avg cfo per ebitDA", field: "s1_data", sub_field: "avg_cfo_per_ebitDA" },
        { title: "avg debtors per creditors", field: "s1_data", sub_field: "avg_debtors_per_creditors" },
        { title: "avg ebitDA per sales", field: "s1_data", sub_field: "avg_ebitDA_per_sales" },
        { title: "avg ebit per ev", field: "s1_data", sub_field: "avg_ebit_per_ev" },
        { title: "avg ev per ebitda", field: "s1_data", sub_field: "avg_ev_per_ebitda" },
        { title: "avg lna per net worth", field: "s1_data", sub_field: "avg_lna_per_net_worth" },
        { title: "avg ns per debtors", field: "s1_data", sub_field: "avg_ns_per_debtors" },
        { title: "avg ns per inventory", field: "s1_data", sub_field: "avg_ns_per_inventory" },
        { title: "avg p per s", field: "s1_data", sub_field: "avg_p_per_s" },
        { title: "avg pb ratio", field: "s1_data", sub_field: "avg_pb_ratio" },
        { title: "avg pcf ratio", field: "s1_data", sub_field: "avg_pcf_ratio" },
        { title: "avg pe ratio", field: "s1_data", sub_field: "avg_pe_ratio" },
        { title: "avg sales per invested capital", field: "s1_data", sub_field: "avg_sales_per_invested_capital" },
        { title: "avg total expenditure per creditors", field: "s1_data", sub_field: "avg_total_expenditure_per_creditors" },
        { title: "benchmark cfo per ebitDA", field: "s1_data", sub_field: "benchmark_cfo_per_ebitDA" },
        { title: "benchmark debtors per creditors", field: "s1_data", sub_field: "benchmark_debtors_per_creditors" },
        { title: "benchmark ebitDA per sales", field: "s1_data", sub_field: "benchmark_ebitDA_per_sales" },
        { title: "benchmark ebit per ev", field: "s1_data", sub_field: "benchmark_ebit_per_ev" },
        { title: "benchmark ev per ebitda", field: "s1_data", sub_field: "benchmark_ev_per_ebitda" },
        { title: "benchmark lna per net worth", field: "s1_data", sub_field: "benchmark_lna_per_net_worth" },
        { title: "benchmark ns per debtors", field: "s1_data", sub_field: "benchmark_ns_per_debtors" },
        { title: "benchmark ns per inventory", field: "s1_data", sub_field: "benchmark_ns_per_inventory" },
        { title: "benchmark p per s", field: "s1_data", sub_field: "benchmark_p_per_s" },
        { title: "benchmark pb ratio", field: "s1_data", sub_field: "benchmark_pb_ratio" },
        { title: "benchmark pcf ratio", field: "s1_data", sub_field: "benchmark_pcf_ratio" },
        { title: "benchmark pe ratio", field: "s1_data", sub_field: "benchmark_pe_ratio" },
        { title: "benchmark sales per invested capital", field: "s1_data", sub_field: "benchmark_sales_per_invested_capital" },
        { title: "benchmark total expenditure per creditors", field: "s1_data", sub_field: "benchmark_total_expenditure_per_creditors" },
        { title: "capex last nine years per cummulative earning", field: "s1_data", sub_field: "capex_last_nine_years_per_cummulative_earning" },
        { title: "capex last nine years per cummulative earning 1 color", field: "s1_data", sub_field: "capex_last_nine_years_per_cummulative_earning_1_color" },
        { title: "capex last nine years per cummulative earning benchmark", field: "s1_data", sub_field: "capex_last_nine_years_per_cummulative_earning_benchmark" },
        { title: "capex last nine years per cummulative earning benchmark 1", field: "s1_data", sub_field: "capex_last_nine_years_per_cummulative_earning_benchmark_1" },
        { title: "capex last nine years per cummulative earning color", field: "s1_data", sub_field: "capex_last_nine_years_per_cummulative_earning_color" },
        { title: "capex last nine years per cummulative nca", field: "s1_data", sub_field: "capex_last_nine_years_per_cummulative_nca" },
        { title: "capex last nine years per cummulative nca 1 color", field: "s1_data", sub_field: "capex_last_nine_years_per_cummulative_nca_1_color" },
        { title: "capex last nine years per cummulative nca benchmark", field: "s1_data", sub_field: "capex_last_nine_years_per_cummulative_nca_benchmark" },
        { title: "capex last nine years per cummulative nca benchmark 1", field: "s1_data", sub_field: "capex_last_nine_years_per_cummulative_nca_benchmark_1" },
        { title: "capex last nine years per cummulative nca color", field: "s1_data", sub_field: "capex_last_nine_years_per_cummulative_nca_color" },
        { title: "capex management", field: "s1_data", sub_field: "capex_management" },
        { title: "earnings growth cagr 10 years benchmark", field: "s1_data", sub_field: "earnings_growth_cagr_10_years_benchmark" },
        { title: "earnings growth cagr 10 years color", field: "s1_data", sub_field: "earnings_growth_cagr_10_years_color" },
        { title: "earnings growth cagr 5 years benchmark", field: "s1_data", sub_field: "earnings_growth_cagr_5_years_benchmark" },
        { title: "earnings growth cagr 5 years color", field: "s1_data", sub_field: "earnings_growth_cagr_5_years_color" },
        { title: "eps growth cagr 10 years benchmark", field: "s1_data", sub_field: "eps_growth_cagr_10_years_benchmark" },
        { title: "eps growth cagr 10 years color", field: "s1_data", sub_field: "eps_growth_cagr_10_years_color" },
        { title: "eps growth cagr 5 years benchmark", field: "s1_data", sub_field: "eps_growth_cagr_5_years_benchmark" },
        { title: "eps growth cagr 5 years color", field: "s1_data", sub_field: "eps_growth_cagr_5_years_color" },
        { title: "free cash flow trends last nine years color", field: "s1_data", sub_field: "free_cash_flow_trends_last_nine_years_color" },
        { title: "govtflag", field: "s1_data", sub_field: "govtflag" },
        { title: "increase in debt per capex last nine years", field: "s1_data", sub_field: "increase_in_debt_per_capex_last_nine_years" },
        { title: "increase in debt per capex last nine years 1 color", field: "s1_data", sub_field: "increase_in_debt_per_capex_last_nine_years_1_color" },
        { title: "increase in debt per capex last nine years benchmark 1", field: "s1_data", sub_field: "increase_in_debt_per_capex_last_nine_years_benchmark_1" },
        { title: "insider acquisition", field: "s1_data", sub_field: "insider_acquisition" },
        { title: "insider disposal", field: "s1_data", sub_field: "insider_disposal" },
        { title: "insider trading", field: "s1_data", sub_field: "insider_trading" },
        { title: "last latest quarter eps", field: "s1_data", sub_field: "last_latest_quarter_eps" },
        { title: "last latest quarter net sales", field: "s1_data", sub_field: "last_latest_quarter_net_sales" },
        { title: "last year free cash flow", field: "s1_data", sub_field: "last_year_free_cash_flow" },
        { title: "last year market share", field: "s1_data", sub_field: "last_year_market_share" },
        { title: "last year market share color", field: "s1_data", sub_field: "last_year_market_share_color" },
        { title: "latest cfo per ebitDA", field: "s1_data", sub_field: "latest_cfo_per_ebitDA" },
        { title: "latest cfo per ebitda benchmark", field: "s1_data", sub_field: "latest_cfo_per_ebitda_benchmark" },
        { title: "latest cfo per ebitda color", field: "s1_data", sub_field: "latest_cfo_per_ebitda_color" },
        { title: "latest competative advantage", field: "s1_data", sub_field: "latest_competative_advantage" },
        { title: "latest competative advantage color", field: "s1_data", sub_field: "latest_competative_advantage_color" },
        { title: "latest consistency analysis", field: "s1_data", sub_field: "latest_consistency_analysis" },
        { title: "latest consistency analysis color", field: "s1_data", sub_field: "latest_consistency_analysis_color" },
        { title: "latest cyclical", field: "s1_data", sub_field: "latest_cyclical" },
        { title: "latest cyclical color", field: "s1_data", sub_field: "latest_cyclical_color" },
        { title: "latest debtors per creditors", field: "s1_data", sub_field: "latest_debtors_per_creditors" },
        { title: "latest debtors per creditors benchmark", field: "s1_data", sub_field: "latest_debtors_per_creditors_benchmark" },
        { title: "latest debtors per creditors color", field: "s1_data", sub_field: "latest_debtors_per_creditors_color" },
        { title: "latest ebitDA per sales", field: "s1_data", sub_field: "latest_ebitDA_per_sales" },
        { title: "latest ebitDA per sales benchmark", field: "s1_data", sub_field: "latest_ebitDA_per_sales_benchmark" },
        { title: "latest ebitDA per sales color", field: "s1_data", sub_field: "latest_ebitDA_per_sales_color" },
        { title: "latest ebit per ev", field: "s1_data", sub_field: "latest_ebit_per_ev" },
        { title: "latest ev per ebitda", field: "s1_data", sub_field: "latest_ev_per_ebitda" },
        { title: "latest free cash flow", field: "s1_data", sub_field: "latest_free_cash_flow" },
        { title: "latest free cash flow color", field: "s1_data", sub_field: "latest_free_cash_flow_color" },
        { title: "latest lna per net worth", field: "s1_data", sub_field: "latest_lna_per_net_worth" },
        { title: "latest lna per net worth benchmark", field: "s1_data", sub_field: "latest_lna_per_net_worth_benchmark" },
        { title: "latest lna per net worth color", field: "s1_data", sub_field: "latest_lna_per_net_worth_color" },
        { title: "latest market share benchmark", field: "s1_data", sub_field: "latest_market_share_benchmark" },
        { title: "latest ns per debtors", field: "s1_data", sub_field: "latest_ns_per_debtors" },
        { title: "latest ns per inventory", field: "s1_data", sub_field: "latest_ns_per_inventory" },
        { title: "latest p per s", field: "s1_data", sub_field: "latest_p_per_s" },
        { title: "latest pb ratio", field: "s1_data", sub_field: "latest_pb_ratio" },
        { title: "latest pcf ratio", field: "s1_data", sub_field: "latest_pcf_ratio" },
        { title: "latest pe ratio", field: "s1_data", sub_field: "latest_pe_ratio" },
        { title: "latest promoter holding", field: "s1_data", sub_field: "latest_promoter_holding" },
        { title: "latest promoter holding color", field: "s1_data", sub_field: "latest_promoter_holding_color" },
        { title: "latest quarter eps", field: "s1_data", sub_field: "latest_quarter_eps" },
        { title: "latest quarter eps benchmark", field: "s1_data", sub_field: "latest_quarter_eps_benchmark" },
        { title: "latest quarter net sales", field: "s1_data", sub_field: "latest_quarter_net_sales" },
        { title: "latest quarter net sales benchmark", field: "s1_data", sub_field: "latest_quarter_net_sales_benchmark" },
        { title: "latest roe benchmark", field: "s1_data", sub_field: "latest_roe_benchmark" },
        { title: "latest roe color", field: "s1_data", sub_field: "latest_roe_color" },
        { title: "latest sales per invested capital", field: "s1_data", sub_field: "latest_sales_per_invested_capital" },
        { title: "latest sales per invested capital benchmark", field: "s1_data", sub_field: "latest_sales_per_invested_capital_benchmark" },
        { title: "latest sales per invested capital color", field: "s1_data", sub_field: "latest_sales_per_invested_capital_color" },
        { title: "latest tax per pbt benchmark", field: "s1_data", sub_field: "latest_tax_per_pbt_benchmark" },
        { title: "latest tax per pbt color", field: "s1_data", sub_field: "latest_tax_per_pbt_color" },
        { title: "latest total debt per net worth benchmark", field: "s1_data", sub_field: "latest_total_debt_per_net_worth_benchmark" },
        { title: "latest total debt per net worth color", field: "s1_data", sub_field: "latest_total_debt_per_net_worth_color" },
        { title: "latest total expenditure per creditors", field: "s1_data", sub_field: "latest_total_expenditure_per_creditors" },
        { title: "latest total taxes accounted", field: "s1_data", sub_field: "latest_total_taxes_accounted" },
        { title: "latest total taxes paid", field: "s1_data", sub_field: "latest_total_taxes_paid" },
        { title: "latest total taxes paid color", field: "s1_data", sub_field: "latest_total_taxes_paid_color" },
        { title: "latest trends more than or equal five yes", field: "s1_data", sub_field: "latest_trends_more_than_or_equal_five_yes" },
        { title: "latest trends more than or equal five yes color", field: "s1_data", sub_field: "latest_trends_more_than_or_equal_five_yes_color" },
        { title: "macro trend", field: "s1_data", sub_field: "macro_trend" },
        { title: "max latest total taxes paid benchmark", field: "s1_data", sub_field: "max_latest_total_taxes_paid_benchmark" },
        { title: "min latest total taxes paid benchmark", field: "s1_data", sub_field: "min_latest_total_taxes_paid_benchmark" },
        { title: "no of positive free cash flow trends", field: "s1_data", sub_field: "no_of_positive_free_cash_flow_trends" },
        { title: "p10 actual", field: "s1_data", sub_field: "p10_actual" },
        { title: "p10 benchmark", field: "s1_data", sub_field: "p10_benchmark" },
        { title: "p10 color", field: "s1_data", sub_field: "p10_color" },
        { title: "p11 actual", field: "s1_data", sub_field: "p11_actual" },
        { title: "p11 benchmark", field: "s1_data", sub_field: "p11_benchmark" },
        { title: "p11 color", field: "s1_data", sub_field: "p11_color" },
        { title: "p1 actual", field: "s1_data", sub_field: "p1_actual" },
        { title: "p1 benchmark", field: "s1_data", sub_field: "p1_benchmark" },
        { title: "p1 color", field: "s1_data", sub_field: "p1_color" },
        { title: "p2 actual", field: "s1_data", sub_field: "p2_actual" },
        { title: "p2 benchmark", field: "s1_data", sub_field: "p2_benchmark" },
        { title: "p2 color", field: "s1_data", sub_field: "p2_color" },
        { title: "p2 retained earning", field: "s1_data", sub_field: "p2_retained_earning" },
        { title: "p3 actual", field: "s1_data", sub_field: "p3_actual" },
        { title: "p3 benchmark", field: "s1_data", sub_field: "p3_benchmark" },
        { title: "p3 color", field: "s1_data", sub_field: "p3_color" },
        { title: "p4 actual", field: "s1_data", sub_field: "p4_actual" },
        { title: "p4 benchmark", field: "s1_data", sub_field: "p4_benchmark" },
        { title: "p4 color", field: "s1_data", sub_field: "p4_color" },
        { title: "p5 a actual", field: "s1_data", sub_field: "p5_a_actual" },
        { title: "p5 a benchmark", field: "s1_data", sub_field: "p5_a_benchmark" },
        { title: "p5 a color", field: "s1_data", sub_field: "p5_a_color" },
        { title: "p5 b actual", field: "s1_data", sub_field: "p5_b_actual" },
        { title: "p5 b benchmark", field: "s1_data", sub_field: "p5_b_benchmark" },
        { title: "p5 b color", field: "s1_data", sub_field: "p5_b_color" },
        { title: "p6 a actual", field: "s1_data", sub_field: "p6_a_actual" },
        { title: "p6 a benchmark", field: "s1_data", sub_field: "p6_a_benchmark" },
        { title: "p6 a color", field: "s1_data", sub_field: "p6_a_color" },
        { title: "p6 b actual", field: "s1_data", sub_field: "p6_b_actual" },
        { title: "p6 b benchmark", field: "s1_data", sub_field: "p6_b_benchmark" },
        { title: "p6 b color", field: "s1_data", sub_field: "p6_b_color" },
        { title: "p7 b actual", field: "s1_data", sub_field: "p7_b_actual" },
        { title: "p7 b benchmark", field: "s1_data", sub_field: "p7_b_benchmark" },
        { title: "p7 b color", field: "s1_data", sub_field: "p7_b_color" },
        { title: "p8 a actual", field: "s1_data", sub_field: "p8_a_actual" },
        { title: "p8 a benchmark", field: "s1_data", sub_field: "p8_a_benchmark" },
        { title: "p8 a color", field: "s1_data", sub_field: "p8_a_color" },
        { title: "p8 b actual", field: "s1_data", sub_field: "p8_b_actual" },
        { title: "p8 b benchmark", field: "s1_data", sub_field: "p8_b_benchmark" },
        { title: "p8 b color", field: "s1_data", sub_field: "p8_b_color" },
        { title: "p9 actual", field: "s1_data", sub_field: "p9_actual" },
        { title: "p9 benchmark", field: "s1_data", sub_field: "p9_benchmark" },
        { title: "p9 color", field: "s1_data", sub_field: "p9_color" },
        { title: "promoter holding benchmark", field: "s1_data", sub_field: "promoter_holding_benchmark" },
        { title: "q1 a", field: "s1_data", sub_field: "q1_a" },
        { title: "q1 a benchmark", field: "s1_data", sub_field: "q1_a_benchmark" },
        { title: "q1 b", field: "s1_data", sub_field: "q1_b" },
        { title: "q1 b benchmark", field: "s1_data", sub_field: "q1_b_benchmark" },
        { title: "q1 c", field: "s1_data", sub_field: "q1_c" },
        { title: "q1 c benchmark", field: "s1_data", sub_field: "q1_c_benchmark" },
        { title: "q1 d", field: "s1_data", sub_field: "q1_d" },
        { title: "q1 d benchmark", field: "s1_data", sub_field: "q1_d_benchmark" },
        { title: "retained earning benchmark", field: "s1_data", sub_field: "retained_earning_benchmark" },
        { title: "retained earning color", field: "s1_data", sub_field: "retained_earning_color" },
        { title: "sales growth cagr 10 years benchmark", field: "s1_data", sub_field: "sales_growth_cagr_10_years_benchmark" },
        { title: "sales growth cagr 10 years color", field: "s1_data", sub_field: "sales_growth_cagr_10_years_color" },
        { title: "sales growth cagr 10 years is gt sector sales cagr 10 years color", field: "s1_data", sub_field: "sales_growth_cagr_10_years_is_gt_sector_sales_cagr_10_years_color" },
        { title: "sales growth cagr 5 years benchmark", field: "s1_data", sub_field: "sales_growth_cagr_5_years_benchmark" },
        { title: "sales growth cagr 5 years color", field: "s1_data", sub_field: "sales_growth_cagr_5_years_color" },
        { title: "sales growth cagr 5 years is gt sector sales cagr 5 years color", field: "s1_data", sub_field: "sales_growth_cagr_5_years_is_gt_sector_sales_cagr_5_years_color" },
        { title: "sector sales cagr 10 years", field: "s1_data", sub_field: "sector_sales_cagr_10_years" },
        { title: "sector sales cagr 10 years color", field: "s1_data", sub_field: "sector_sales_cagr_10_years_color" },
        { title: "sector sales cagr 5 years", field: "s1_data", sub_field: "sector_sales_cagr_5_years" },
        { title: "sector sales cagr 5 years color", field: "s1_data", sub_field: "sector_sales_cagr_5_years_color" },
        { title: "total free cash flow trends", field: "s1_data", sub_field: "total_free_cash_flow_trends" },
        { title: "valuation trends cfo per ebitDA", field: "s1_data", sub_field: "valuation_trends_cfo_per_ebitDA" },
        { title: "valuation trends debtors per creditors", field: "s1_data", sub_field: "valuation_trends_debtors_per_creditors" },
        { title: "valuation trends ebitDA per sales", field: "s1_data", sub_field: "valuation_trends_ebitDA_per_sales" },
        { title: "valuation trends ebit per ev", field: "s1_data", sub_field: "valuation_trends_ebit_per_ev" },
        { title: "valuation trends ev per ebitda", field: "s1_data", sub_field: "valuation_trends_ev_per_ebitda" },
        { title: "valuation trends lna per net worth", field: "s1_data", sub_field: "valuation_trends_lna_per_net_worth" },
        { title: "valuation trends ns per debtors", field: "s1_data", sub_field: "valuation_trends_ns_per_debtors" },
        { title: "valuation trends ns per inventory", field: "s1_data", sub_field: "valuation_trends_ns_per_inventory" },
        { title: "valuation trends p per s", field: "s1_data", sub_field: "valuation_trends_p_per_s" },
        { title: "valuation trends pb ratio", field: "s1_data", sub_field: "valuation_trends_pb_ratio" },
        { title: "valuation trends pcf ratio", field: "s1_data", sub_field: "valuation_trends_pcf_ratio" },
        { title: "valuation trends pe ratio", field: "s1_data", sub_field: "valuation_trends_pe_ratio" },
        { title: "valuation trends sales per invested capital", field: "s1_data", sub_field: "valuation_trends_sales_per_invested_capital" },
        { title: "valuation trends total expenditure per creditors", field: "s1_data", sub_field: "valuation_trends_total_expenditure_per_creditors" },
        { title: "z1 actual", field: "s1_data", sub_field: "z1_actual" },
        { title: "z1 benchmark", field: "s1_data", sub_field: "z1_benchmark" },
        { title: "Sector Name", field: "sector_name", sub_field: "" }
      ],
      rawDataApi: "frontend/profile_allocation_s1s_to_market/get",
      apiUrl: "",
      rawData: [],
      searchData: [],
      searchText: "",
      curYear: new Date().getFullYear(),
      minRange: [],
      maxRange: [],
      filterOptions: [
        {
          id: "",
          value: "Select",
          isNumeric: true,
          sort_order: 0
        }
      ],
      selFilter: [],
      selRangeFilter: 0,
      type: "s1",
      sectorData: [],
      sectorname: "",
      page: 1,
      perPage: 700,
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: [],
      isDownload: 0,
      appTitle: "",
      dateFilterTabWiseData: [],
    };
  },
  methods: {
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.prevDisabled = 0;
      this.fillTable();
    },
    fillTable() {
      this.page = this.pageToLoad;
      if (this.pageToLoad == this.totalPages) {
        this.nextDisabled = 1;
      } else {
        this.nextDisabled = 0;
      }
      if (this.pageToLoad == 1) {
        this.prevDisabled = 1;
      } else {
        this.prevDisabled = 0;
      }
      this.current_page = this.pageToLoad;
      //this.getS1Data();
    },

    clearData() {
      this.selRangeFilter = 0;
      this.selFilter = "";
      this.sectorname = "";
      this.searchText = "";
      this.sectorname = "";
      this.searchText = "";
      this.selFilter[2] = "p11_quarterly_trends";
      this.ddate = new Date().setDate(new Date().getDate() - 1);
      this.minRange[0] = this.minRange[1] = this.minRange[2] = this.maxRange[0] = this.maxRange[1] = this.maxRange[2] =
        "";
      //this.rawData = this.searchData;
    },
    /* getDateData(e) {
      console.log("Date Selected", e);
      this.ddate = e;
      //this.getS1Data();
    }, */
    downloadAll() {
      this.isDownload = 1;
      //this.getS1Data();
    }
  },
  watch: {
    sectorList(value) {
      /* value.forEach((val, key) => {
        console.log('Object.keys:::', Object.keys(val));
        }); */
      console.log('watch sectorList', value[0]);
      if (value[0] !== undefined) {
        console.log('watch value:::', value[0]);
        console.log('Object.keys:::', Object.keys(value[0]));
        this.rawData = value;
      }
    },
    /* title(value) {
      this.appTitle = value;
    } */
  },
  computed: {
    filterOptions0: function () {
      return this.filterOptions.filter(function (row, index) {
        return row.id === "p11_actual";
      });
    },
    filterOptions1: function () {
      return this.filterOptions.filter(function (row, index) {
        return row.id === "q1_a_b_greater";
      });
    },
    filterOptions2: function () {
      return this.filterOptions.filter(function (row, index) {
        return row.id === "p11_quarterly_trends";
        // return row.id === "q1_S" || row.id === "q1_a_S" || row.id === "q1_b_S" || row.id === "q1_c_S" || row.id === "q1_d_S";
      });
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}

.table td {
  padding: 5px 10px 5px 10px;
}

</style>



// WEBPACK FOOTER //
// src/views/market-data/s1s-sector.vue